module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hresh1x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "unLoadBool": true,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHresh1xIndex,
      "maxRowspan": _vm.maxRowspan.index,
      "searchBoxAlias": "hresh1x",
      "csvExportDisp": false,
      "detailEvent": _vm.detailEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "indexSelected": _vm.indexSelected,
      "codempid": _vm.codempid,
      "descCodempid": _vm.app.currentUser.username[_vm.app.nowLang],
      "detail": _vm.detail,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "tab3Table": _vm.columns[_vm.app.nowLang].detailTab3
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7391644!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hresh1x/component.vue
// module id = 3949
// module chunks = 1